/**
 * 计算滚动条宽度的工具函数
 * 用于防止模态框或下拉菜单打开时页面震动
 */

let scrollbarWidth: number | null = null;

/**
 * 计算滚动条宽度
 */
export function getScrollbarWidth(): number {
  if (scrollbarWidth !== null) {
    return scrollbarWidth;
  }

  // 创建一个临时的div来测量滚动条宽度
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  // 确保在IE中显示滚动条(非标准属性,标准 CSSStyleDeclaration 类型里没有)
  (outer.style as CSSStyleDeclaration & { msOverflowStyle?: string }).msOverflowStyle = 'scrollbar';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  outer.parentNode?.removeChild(outer);

  return scrollbarWidth;
}

/**
 * 设置CSS变量来存储滚动条宽度
 */
export function setScrollbarWidthCSSVariable(): void {
  const width = getScrollbarWidth();
  document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
}

/**
 * 在页面加载时初始化滚动条宽度
 */
export function initScrollbarWidth(): void {
  if (typeof window !== 'undefined') {
    // 立即设置
    setScrollbarWidthCSSVariable();
    
    // 在DOM加载完成后再次设置，确保准确性
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setScrollbarWidthCSSVariable);
    }
    
    // 在窗口大小改变时重新计算
    window.addEventListener('resize', () => {
      scrollbarWidth = null; // 重置缓存
      setScrollbarWidthCSSVariable();
    });
  }
}

/**
 * 防止页面震动的辅助函数
 * 在打开模态框或下拉菜单前调用
 */
export function preventBodyShake(): void {
  const width = getScrollbarWidth();
  if (width > 0) {
    document.body.style.paddingRight = `${width}px`;
    document.body.style.overflow = 'hidden';
  }
}

/**
 * 恢复页面正常状态
 * 在关闭模态框或下拉菜单后调用
 */
export function restoreBodyScroll(): void {
  document.body.style.paddingRight = '';
  document.body.style.overflow = '';
}